// AriaStateIndicator — ARIA's presence line. Communicates what the
// system is doing right now (watching, thinking, listening) and what
// it's connected to, so the panel never reads as dead space.
// state: 'watching' | 'thinking' | 'listening'
import React from 'react';

const STATE_TEXT = {
  watching: 'watching',
  thinking: 'thinking…',
  listening: 'listening…',
};

export default function AriaStateIndicator({ state = 'watching', sources = [], lastSync }) {
  const srcText = sources.length > 0 ? sources.join(', ') : 'workspace not connected';
  return (
    <div className={`hm-aria-state hm-aria-state-${state}`} role="status" aria-live="polite">
      <span className="hm-aria-state-dot" aria-hidden="true" />
      <span className="hm-aria-state-text">
        ARIA · {STATE_TEXT[state] || 'watching'} {state === 'watching' ? srcText : ''}
        {state === 'watching' && lastSync ? ` · synced ${lastSync}` : ''}
      </span>
    </div>
  );
}
